import { createAction, props } from "@ngrx/store";
import { IErrors } from "../../models/error";
import { IBookResponse } from "../../models/book";


enum BookActions {

    // Fetch Book Info
    FetchBookInfo = '[Book] Fetch Book Info',
    FetchBookInfoSuccess = '[Book] Fetch Book Info Success',
    FetchBookInfoFailure = '[Book] Fetch Book Info Failure',

}

// Client Info
export const FetchBookInfoAction = createAction(
    BookActions.FetchBookInfo,
    props<{ bookId: string }>()
)
export const FetchBookInfoSuccessAction = createAction(
    BookActions.FetchBookInfoSuccess,
    props<{ response: IBookResponse }>()
)
export const FetchBookInfoFailureAction = createAction(
    BookActions.FetchBookInfoFailure,
    props<{ error: IErrors }>()
)

